module.exports = __webpack_public_path__ + "media/囧囧.1b4b1c37.mp3";